import * as R from 'ramda';
import { useNavigate } from 'react-router-dom';

// Original routes object
const routes = {
  login: "/auth/login",
  home: "/",
  notFound: "/errors/not-found",
  forbidden: "/errors/forbidden",
  help: "/help"
} as const;

type Routes = typeof routes;

type Capitalize<S extends string> = S extends `${infer First}${infer Rest}`
  ? `${Uppercase<First>}${Rest}`
  : S;

type NavigateToKeys<TP,T extends Record<string, string>> = {
  [K in keyof T as `navigateTo${Capitalize<K & string>}`]: () => void;
};

// Helper function to capitalize the first letter of a string
const capitalize = (str: string) => R.toUpper(R.head(str)) + R.tail(str);

// Function to transform the keys of the routes object
export const useNavigateTo = (): NavigateToKeys<() => void,Routes> => {
  const navigate = useNavigate();
  return R.toPairs(routes).reduce((acc, [key, value]) => {
    const newKey = `navigateTo${capitalize(key)}`;
    (acc as any)[newKey] = () => () => navigate(value);
    return acc;
  }, {} as NavigateToKeys<() => void,Routes>);
};
